import { coworkingSubTypes } from '../../../browser/addform/scripts/enums/commercial-object-types';

export interface IParams {
  isWorkPlacesAvailable?: boolean;
}

export const getCoworkingSubTypes = (params: IParams = {}) => {
  const { isWorkPlacesAvailable = false } = params;

  if (isWorkPlacesAvailable) {
    return coworkingSubTypes.map(item => {
      if (['fixedWorkplace', 'flexibleWorkplace'].includes(item.key)) {
        return {
          ...item,
          disabled: false,
        };
      }

      return item;
    });
  }

  return coworkingSubTypes;
};
